import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import _uniq from 'lodash-es/uniq';

import type { EntityKeyframesAppState } from './types';

type KeyframesPayload = {
  entityId: string;
  ids: string[];
};

type DeleteKeyframePayload = {
  entityId: string;
  id: string;
};

type LoadingPayload = {
  entityId: string;
  loading: boolean;
};

const initialState: EntityKeyframesAppState = {
  keyframesIdsByEntityId: {},
  loadingByEntityId: {},
};

export const entityKeyframesSlice = createSlice({
  name: 'entity_keyframes',
  initialState,
  reducers: {
    setEntityKeyframesIds: (state, action: PayloadAction<KeyframesPayload>) => {
      state.keyframesIdsByEntityId[action.payload.entityId] = _uniq(
        action.payload.ids,
      );
    },
    deleteEntityKeyframe: (
      state,
      action: PayloadAction<DeleteKeyframePayload>,
    ) => {
      const existing =
        state.keyframesIdsByEntityId[action.payload.entityId] ?? [];
      state.keyframesIdsByEntityId[action.payload.entityId] = existing.filter(
        (id) => id !== action.payload.id,
      );
    },
    entityKeyframesLoadingUpdated: (
      state,
      action: PayloadAction<LoadingPayload>,
    ) => {
      state.loadingByEntityId[action.payload.entityId] = action.payload.loading;
    },
  },
});

export const {
  setEntityKeyframesIds,
  deleteEntityKeyframe,
  entityKeyframesLoadingUpdated,
} = entityKeyframesSlice.actions;

export const entityKeyframesReducer = entityKeyframesSlice.reducer;
